export default {
  THUMBNAIL: 'thumbnail',
  CHECKBOX: 'checkbox',
};
